import { render } from "./QuizMultiple.vue?vue&type=template&id=525d91e4"
import script from "./QuizMultiple.vue?vue&type=script&lang=js"
export * from "./QuizMultiple.vue?vue&type=script&lang=js"

import exportComponent from "/home/vueltaciclista/app/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__